import React from "react";
import styled from "styled-components";
import { IPageSectionResponse } from "models/response/page-section-response";
import { SectionTitle } from "../custom-page.styles";

const MixedContentContainer = styled.div`
  margin-bottom: 30px;
`;

const ContentItem = styled.div<{ $hasImage: boolean }>`
  display: grid;
  grid-template-columns: ${props => props.$hasImage ? '1fr 1fr' : '1fr'};
  gap: 30px;
  margin-bottom: 40px;
  padding: 25px;
  background: #f9f9f9;
  border-radius: 8px;
  align-items: center;

  &:nth-child(even) {
    direction: rtl;

    > * {
      direction: ltr;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 20px;
    margin-bottom: 25px;

    &:nth-child(even) {
      direction: ltr;
    }
  }
`;

const ContentImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const ContentTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContentTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ContentSubtitle = styled.h4`
  font-size: 18px;
  font-weight: 500;
  color: #666;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ContentDescription = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #555;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const ContentLink = styled.a`
  display: inline-block;
  padding: 10px 20px;
  background-color: #1976d2;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: background-color 0.3s ease;
  align-self: flex-start;

  &:hover {
    background-color: #1565c0;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 14px;
  }
`;

interface MixedContentSectionProps {
    section: IPageSectionResponse;
}

export const MixedContentSection: React.FC<MixedContentSectionProps> = ({ section }) => {
    if (!section.items || section.items.length === 0) {
        return null;
    }

    const sortedItems = [...section.items].sort((a, b) => a.order - b.order);

    return (
        <MixedContentContainer>
            {section.title && <SectionTitle>{section.title}</SectionTitle>}
            {sortedItems.map((item) => (
                <ContentItem key={item.id} $hasImage={!!item.imageUrl}>
                    {item.imageUrl && (
                        <ContentImage src={item.imageUrl} alt={item.title || ''} />
                    )}
                    <ContentTextWrapper>
                        {item.title && <ContentTitle>{item.title}</ContentTitle>}
                        {item.subtitle && <ContentSubtitle>{item.subtitle}</ContentSubtitle>}
                        {item.description && <ContentDescription>{item.description}</ContentDescription>}
                        {item.url && (
                            <ContentLink href={item.url} target="_blank" rel="noopener noreferrer">
                                Saiba mais
                            </ContentLink>
                        )}
                    </ContentTextWrapper>
                </ContentItem>
            ))}
        </MixedContentContainer>
    );
};
